
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    root: {
        //overflowY: 'auto',
        backgroundColor: 'red'
    }
})

const OperationList = ({
    items,
    onRenderOperation
}) => {
    let n = -1;
    return (
        <Stack className={classNames.root}>
            {items.map(item => {
                n = (n+1) % 2;
                return onRenderOperation(item, n);
            })}
        </Stack>
    );
}

export default OperationList;
